<!-- Solution Participation Refreshed UI: Summary lives outside the legacy page-container, full width -->
@if (useRefreshedSolutionParticipationUI) {
  <section class="refreshed-summary-section flex flex-col bg-light-blue ml-neptune-sidebar px-8 py-6" id="refreshed-summary-section">
      <app-solution-participation-summary [numSolutions]="numSolutions" [currencySymbol]="currencySymbol" [isLoading]="displayLoader || isCurrencyLoading"></app-solution-participation-summary>
  </section>

<div class="refreshed-summary-section flex flex-col bg-light-blue ml-neptune-sidebar px-8 py-2 box-border">
    <div class="bg-white">
        <!-- Neptune View Selector: Location View / Solution Group View -->
        @if (!disableLocationView) {
            <div id="sp-view-selector" class="flex border border-solid border-sky-blue">
                <div id="sp-location-view-tab"
                    role="button"
                    tabindex="0"
                    class="flex flex-1 items-center justify-center gap-3 py-3.5 border-r border-solid border-sky-blue cursor-pointer"
                    [ngClass]="tabSelected === 'location-view'
                        ? 'bg-blue text-white'
                        : 'bg-white text-neptune-neutral'"
                    [attr.aria-pressed]="tabSelected === 'location-view'"
                    (click)="changeTab('location-view')"
                    (keydown.enter)="changeTab('location-view')"
                    (keydown.space)="$event.preventDefault(); changeTab('location-view')">
                    <input type="radio"
                        name="solutionParticipationViewSelection"
                        id="sp-location-view-radio"
                        value="location-view"
                        aria-label="Location View"
                        [checked]="tabSelected === 'location-view'"
                        class="pointer-events-none appearance-none m-0 w-6 h-6 min-w-6 rounded-[50%] border-solid border-[2px] border-neptune-neutral checked:border-white checked:bg-[radial-gradient(circle,white_40%,#006BD3_50%)]" />
                    <span class="text-sm font-medium tracking-[0.1px]"
                        [ngClass]="{'selectedTab !bg-transparent !text-white !border-b-0 !mb-0 !font-medium': tabSelected === 'location-view'}">Location
                        View</span>
                </div>
                <div id="sp-solution-view-tab"
                    role="button"
                    tabindex="0"
                    class="flex flex-1 items-center justify-center gap-3 py-3.5 cursor-pointer"
                    [ngClass]="tabSelected === 'solution-group-view'
                        ? 'bg-blue text-white'
                        : 'bg-white text-neptune-neutral'"
                    [attr.aria-pressed]="tabSelected === 'solution-group-view'"
                    (click)="changeTab('solution-group-view')"
                    (keydown.enter)="changeTab('solution-group-view')"
                    (keydown.space)="$event.preventDefault(); changeTab('solution-group-view')">
                    <input type="radio"
                        name="solutionParticipationViewSelection"
                        id="sp-solution-group-view-radio"
                        value="solution-group-view"
                        aria-label="Solution Group View"
                        [checked]="tabSelected === 'solution-group-view'"
                        class="pointer-events-none appearance-none m-0 w-6 h-6 min-w-6 rounded-[50%] border-solid border-[2px] border-neptune-neutral checked:border-white checked:bg-[radial-gradient(circle,white_40%,#006BD3_50%)]" />
                    <span class="text-sm font-medium tracking-[0.1px]"
                        [ngClass]="{'selectedTab !bg-transparent !text-white !border-b-0 !mb-0 !font-medium': tabSelected === 'solution-group-view'}">Solution
                        Group
                        View</span>
                </div>
            </div>
        }

        <!-- Neptune Location View -->
        @if (!disableLocationView && tabSelected === 'location-view') {
            <section class="bg-white flex flex-col p-6" id="sp-location-view-container">
                <app-solution-groups-table id="sp-location-view-table"></app-solution-groups-table>
            </section>
        }
    </div>
</div>


}

<page-container *ngIf="!useRefreshedSolutionParticipationUI" [border]="true" class="flex justify-center">
    <div class="spd-wrapper">
        <div class="spd-title-bar">
            <div class="title">{{pageTitle}}</div><div class="subtitle">&nbsp;&nbsp;|&nbsp; {{makeSPDPageSubtitle()}}</div>
        </div>

        <!-- Solution Participation V2 Changes- Feature #364952 -->
        <ng-container *ngIf="!useRefreshedSolutionParticipationUI">
          <section class="summary-graph-section" id="summary-graph-section">
              <loader [size]="'medium'" *ngIf="isCurrencyLoading"></loader>
              <div id="summary-block" *ngIf="!isCurrencyLoading">
                  <div id="summary-header">
                      <div id="summary-title">
                          <img src="/assets/summary-nav-icon.svg" alt="nav-icon"/>
                          <span class="title">Summary</span>
                      </div>
                      <div class="period-selected">
                          &nbsp;&nbsp;|&nbsp;&nbsp;{{periodValue}}
                      </div>
                  </div>
                  <div id="summary-box-container">
                      <app-solution-participation-summary [numSolutions]="numSolutions" [currencySymbol]="currencySymbol"></app-solution-participation-summary>
                  </div>
              </div>
          </section>
        </ng-container>

        <!-- Tabs section -->
        <!-- Feature Flag Dependant -->
        <ng-container *ngIf="!disableLocationView">
          <section class="sg-tabs-container">
            <div class="sg-tab hover-pointer" data-id="location-view-tab" [ngClass]="{'selectedTab': tabSelected === 'location-view'}" (click)="changeTab('location-view')">
                <span class="location-view-icon">
                  <img src="/assets/solution-participation/location-view-icon.svg" alt="location-view-icon">
                </span>
                Location View
            </div>
            <div class="sg-tab hover-pointer" data-id="solution-group-view-tab"  [ngClass]="{'selectedTab': tabSelected === 'solution-group-view'}" (click)="changeTab('solution-group-view')">
              <span class="solution-view-icon">
                <img src="/assets/bar-graph-icon.svg" alt="solution-view-icon">
              </span>
              Solution Group View
            </div>
            <div class="period-selected">
              &nbsp;|&nbsp;&nbsp;{{periodValue}}
            </div>
          </section>
        </ng-container>

        <!-- Solution Groups Graph Section -->
        <section class="solution-graphs-section">
            <loader [size]="'medium'" *ngIf="displayGraphLoader || isCurrencyLoading"></loader>
            <div id="graph-block" *ngIf="!displayGraphLoader && !isCurrencyLoading">
                <div class="graph-header" *ngIf="disableLocationView">
                  <div class="graph-title" id="graph-title">
                      <img src="/assets/bar-graph-icon.svg" alt="bar-graph-icon"/>
                      <span class="title">Percentage of Locations with Sales Opportunities</span>
                  </div>
                  <div class="period-selected" id="period">
                      &nbsp;&nbsp;|&nbsp;&nbsp;{{periodValue}}
                  </div>
                </div>

                <div id="charts-block" [ngClass]="{'location-view-charts': !disableLocationView}">
                  <!-- Widget Gauge Chart- SP v3 -->
                  <div class="widget-gauge-chart" *ngIf="!disableLocationView" [ngClass]="{'chart-not-in-focus': tabSelected !== 'location-view'}" >
                    <app-location-overview-gauge-chart
                      [useRefreshedUi]="useRefreshedSolutionParticipationUI">
                    </app-location-overview-gauge-chart>
                  </div>
                  <!-- Bar Graphs Section -->
                  <section class="bar-graphs-section">
                    <div class="top-solutions-chart" [ngClass]="{'location-view-charts': !disableLocationView,'chart-not-in-focus': tabSelected !== 'solution-group-view'}">
                      <ng-container *ngIf="solutionGroupNames.length; else noData">
                          <solution-group-graph [solutionGroupNames]="solutionGroupNames" [chartValues]="usageValues" [complianceLocationNumbers]="usageTotalValues" [totalLocationNumbers]="totalLocationsValues" [graphName]="'Top Solution Groups'" [id]="'groups'"
                          [currencySymbol]="currencySymbol">
                          </solution-group-graph>
                      </ng-container>
                      <ng-template #noData>
                          <div id="no-data-message-groups" class="no-data-message">No sales data available for filter selection.</div>
                      </ng-template>
                    </div>
                    <div class="sales-opportunities-chart" [ngClass]="{'location-view-charts': !disableLocationView,'chart-not-in-focus': tabSelected !== 'solution-group-view'}">
                        <ng-container *ngIf="salesSolutiongroups.length; else noData">
                            <solution-group-graph [solutionGroupNames]="salesSolutiongroups" [chartValues]="salesData" [graphName]="'Top Field Sales and Opportunity'"
                            [opportunityValues]="opportunityValues" [id]="'sales'" [currencySymbol]="currencySymbol">
                            </solution-group-graph>
                        </ng-container>
                        <ng-template #noData>
                            <div id="no-data-message-sales" class="no-data-message">No sales data available for filter selection.</div>
                        </ng-template>
                    </div>
                  </section>
                </div>
            </div>
        </section>

        <ng-container *ngIf="solutionViewEnabled">
          <!-- Trends Section -->
          <section id="content-section">
              <div id="content-header">
                  <div id="content-title">
                      <img src="/assets/trends_icon.svg" alt="trends_icon"/>
                      <span class="title">Trends</span>
                  </div>
                  <div id="content-subtitle">
                      &nbsp;&nbsp;|&nbsp;&nbsp;{{sumLocations}} Locations within {{dataSource.data.length}} Solution Groups
                  </div>
              </div>

              <div id="table-buttons">
                  <div class="tb-tab hover-pointer" [ngClass]="{'selectedTab': currSortType === 'Sales'}" (click)="onCaseToggle()">
                      Sales Trend&nbsp;&nbsp;
                      <span *ngIf="totalSalesOfFiltered >= 1000000">({{currencyCode | currencySymbol}}{{totalSalesOfFiltered | million}})</span>
                      <span *ngIf="totalSalesOfFiltered < 1000000">({{currencyCode | currencySymbol}}{{totalSalesOfFiltered | number:'1.0-0'}})</span>
                  </div>
                  <div class="tb-tab hover-pointer" [ngClass]="{'selectedTab': currSortType === 'Cases'}" (click)="onCaseToggle()">
                      Cases Trend&nbsp;&nbsp;
                      <span *ngIf="totalCasesOfFiltered >= 1000000">({{totalCasesOfFiltered | million}})</span>
                      <span *ngIf="totalCasesOfFiltered < 1000000">({{totalCasesOfFiltered | number:'1.0-0'}})</span>
                  </div>
              </div>

              <div id="search-row">
                  <div class="search-box">
                      <img src="assets/gray-search-icon.png" class="search-icon" alt="search-icon">
                      <input placeholder="Search Solution Group" [(ngModel)]="searchTerm" (ngModelChange)="onSearch(searchTerm)"
                      (focus)="onSearchFocus()" (blur)="onSearchBlur()">
                  </div>
              </div>

              <div class="sol-part-filter-pagination">
                  <loader [size]="'small'" *ngIf="displayLoaderForFilterData"></loader>
                  <div id="sol-part-summary-advanced-filters" *ngIf="!displayLoaderForFilterData" class="neptune-advanced-filters">
                      <advanced-filters
                          [advancedFilterData]="advancedFilterData"
                          [pageScope] = "'Solution Participation Summary'"
                          [selectedAdvancedFilters] = "selectedAdvancedFilters"
                          (selectedFilters) = "onSelectedFiltersChange($event)"
                          [useRefreshedUi]="true"
                          [(toggleBody)]="toggleAdvancedFilterSelection"
                      ></advanced-filters>
                      <advanced-filters-selection
                          [advancedFilterData]="advancedFilterData"
                          [pageScope]="'Solution Participation Summary'"
                          [selectedAdvancedFilters]="selectedAdvancedFilters"
                          (selectedFilters)="onSelectedFiltersChange($event)"
                          [(toggleBody)]="toggleAdvancedFilterSelection"
                      >
                      </advanced-filters-selection>
                  </div>

                  <mat-paginator
                      id="spd-paginator"
                      [pageSizeOptions]="pageSizeOptions"
                      aria-label="Select page"
                      [length]="dataSource.data.length"
                      class = "sol-part-summary-pagination"
                      >
                  </mat-paginator>
              </div>

              <loader [size]="'medium'" *ngIf="displayLoader"></loader>

              <div class="table-container">
                  <table
                          [dataSource]="dataSource"
                          mat-table
                          matTableFilter
                          matSort
                          (matSortChange)="onSortChange($event)"
                          [hidden]="displayLoader"
                          >
                  <ng-container matColumnDef="solutionGroup">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header="solutionGroup">Solution Group </th>
                      <td mat-cell *matCellDef="let element" >
                          <div class="td-cell-inner-center">
                              <solution-group-cell [SGCData]="element.SolutionGroup" style="width:min-content;"></solution-group-cell>
                          </div>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="locationCompliance">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header="locationCompliance"> Location Usage </th>
                      <td mat-cell *matCellDef="let element">
                          <div class="td-cell-inner-center" style="width:200px;">
                              <location-compliance-cell [locationComplianceCell]="element.LocationComplianceCell" (onUsageClick)="this.ViewByNavigation('location', element.SolutionGroup.name, $event)"></location-compliance-cell>
                          </div>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="sales">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header="sales"> {{currSortType}} </th>
                      <td mat-cell *matCellDef="let element" >
                          <div class="td-cell-inner-center">
                              <div *ngIf="isCasesSelected" class="text-bold cases-text">{{element.Sales.toLocaleString('en-US')}}</div>
                              <div *ngIf="!isCasesSelected" class="text-bold sales-text">{{currencyCode | currencySymbol}}{{element.Sales | number : '1.2-2' : 'en-US'}}</div>
                          </div>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="salesTrend" >
                      <th mat-header-cell *matHeaderCellDef > {{currSortType}} Trend </th>
                      <td mat-cell *matCellDef="let element" >
                          <div class="td-cell-inner-center">
                              <div class="line-chart-cell">
                                  <line-chart [xAxisCategories]="element.SalesTrend.xAxisCategories" [yAxisCategories]="element.SalesTrend.yAxisCategories"></line-chart>
                              </div>
                          </div>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="linksToViewBy" >
                      <th mat-header-cell *matHeaderCellDef id="actions-head">Actions</th>
                      <td mat-cell *matCellDef="let element" >
                          <div class="td-cell-inner-center">
                              <div class="elipses-container hover-pointer" (click)="toggleRowMenu('spd-'+element.SolutionGroup.name); $event.stopPropagation()" [ngClass]="{
                                  'elipses-hover-selected' : isRowMenuOpen('spd-'+element.SolutionGroup.name)
                                  }">
                                  <div class="elipse" ></div>
                                  <div class="elipse" ></div>
                                  <div class="elipse" ></div>
                              </div>
                              <div class="tooltip-container" [hidden]="!isRowMenuOpen('spd-'+element.SolutionGroup.name)" appClickOutside (appClickOutside)="closeRowMenu()" (click)="$event.stopPropagation()">

                                  <div class='viewByLink hover-pointer' (click)="ViewByNavigation('location', element.SolutionGroup.name, false)">View By Location Details</div>
                                  <div class='viewByLink hover-pointer' (click)="ViewByProducts('products',element.SolutionGroup.name)">View By Product Details</div>
                              </div>
                          </div>
                      </td>
                  </ng-container>

                  <tr class="mat-row box-shadow" *matNoDataRow>
                      <td class="mat-cell" [attr.colspan]="displayColumns.length" style="text-align:center;">
                      Solution Group not found.
                      </td>
                  </tr>
                  <tr mat-header-row class="box-shadow" *matHeaderRowDef="displayColumns;"></tr>
                  <tr mat-row class="box-shadow" *matRowDef="let row; columns: displayColumns;">
                  </tr>
                  </table>
              </div>
          </section>
        </ng-container>

        <ng-container *ngIf="!solutionViewEnabled">
          <!-- Solution Participation V3:  US-473787/8 -->
          <app-solution-groups-table></app-solution-groups-table>
        </ng-container>
    </div>

</page-container>
